export default __webpack_public_path__ + "static/media/arrow.c01997a7.svg";